import { render, staticRenderFns } from "./Subnavbar-ventas.vue?vue&type=template&id=33d9fe4a&scoped=true"
import script from "./Subnavbar-ventas.vue?vue&type=script&lang=js"
export * from "./Subnavbar-ventas.vue?vue&type=script&lang=js"
import style0 from "./Subnavbar-ventas.vue?vue&type=style&index=0&id=33d9fe4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d9fe4a",
  null
  
)

export default component.exports